import esContent from './template.es';

export default {
  ...esContent,
};
